import axios from 'axios';
import {
  ChannelResponse,
  NotificationResponse,
  DeliveryFeeResponse,
} from './type';
import {
  BIZ_DEV_API_URL,
  BIZ_LIVE_API_URL,
  BIZ_TEST_API_URL,
  COMMON_DEV_API_URL,
  COMMON_LIVE_API_URL,
  COMMON_TEST_API_URL,
  IMAGE_DEV_API_URL,
  IMAGE_LIVE_API_URL,
  IMAGE_TEST_API_URL,
} from './ConstantApi';
import { ResStatus } from './enum';

export const getKakaoRedirectUrl = () => {
  if (window.location.href.includes('https://biz.minthouse.kr')) {
    return 'https://biz.minthouse.kr/auth/kakao';
  } else if (window.location.href.includes('https://test-biz.minthouse.kr')) {
    return 'https://test-biz.minthouse.kr/auth/kakao';
  } else if (window.location.href.includes('https://dev-biz.minthouse.kr')) {
    return 'https://dev-biz.minthouse.kr/auth/kakao';
  } else {
    return 'http://localhost:3000/auth/kakao';
  }
};
export const getNaverRedirectUrl = () => {
  if (window.location.href.includes('https://biz.minthouse.kr')) {
    return 'https://biz.minthouse.kr/auth/naver';
  } else if (window.location.href.includes('https://test-biz.minthouse.kr')) {
    return 'https://test-biz.minthouse.kr/auth/naver';
  } else if (window.location.href.includes('https://dev-biz.minthouse.kr')) {
    return 'https://dev-biz.minthouse.kr/auth/naver';
  } else {
    return 'http://localhost:3000/auth/naver';
  }
};

export const getCommonAPIURL = () => {
  if (window.location.href.includes('https://biz.minthouse.kr')) {
    return COMMON_LIVE_API_URL;
  } else if (window.location.href.includes('https://test-biz.minthouse.kr')) {
    return COMMON_TEST_API_URL;
  } else {
    return COMMON_DEV_API_URL;
  }
};

export const getImageAPIURL = () => {
  if (window.location.href.includes('https://biz.minthouse.kr')) {
    return IMAGE_LIVE_API_URL;
  } else if (window.location.href.includes('https://test-biz.minthouse.kr')) {
    return IMAGE_TEST_API_URL;
  } else {
    return IMAGE_DEV_API_URL;
  }
};
export const getAPIURL = () => {
  if (window.location.href.includes('https://biz.minthouse.kr')) {
    return BIZ_LIVE_API_URL;
  } else if (window.location.href.includes('https://test-biz.minthouse.kr')) {
    return BIZ_TEST_API_URL;
  } else {
    return BIZ_DEV_API_URL;
  }
};
export const getPGType = () => {
  if (window.location.href.includes('https://biz.minthouse.kr')) {
    return 'html5_inicis.MOIminth69';
  } else if (window.location.href.includes('https://test.biz.minthouse.kr')) {
    return 'html5_inicis';
  } else {
    return 'html5_inicis';
  }
};

const axiosInstance = axios.create({
  baseURL: getAPIURL(),
  headers: {
    'Content-Type': 'application/json',
  },
});

type AxiosParams = {
  access_token: string;
  device_type: number;
  command: any;
};
type FetchParams = {
  method: string;
  headers: any;
  body: any;
};

export const getAxiosRequestData = (data: any): AxiosParams => {
  const accessToken = localStorage.getItem('accessToken');
  return {
    access_token: accessToken ? accessToken : '',
    device_type: 0, // 0(IOS) / 1 (ANDROID)
    command: data,
  };
};
export const getFetchRequestData = (data: any): FetchParams => {
  const accessToken = localStorage.getItem('accessToken');
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      access_token: accessToken ? accessToken : '',
      device_type: 0,
      command: data,
    }),
  };
};

export const queryApi = async (url: string, data: any) => {
  const requestData = await getAxiosRequestData(data);
  console.log('queryApi : ', url, data, requestData);

  return axiosInstance.post(url, requestData).then((response) => {
    console.log('response : ', response.data);

    if (response.data.access_token && response.data.access_token !== '') {
      localStorage.setItem('accessToken', response.data.access_token);
    }
    if (response.data.status === ResStatus.RES_UNAUTHORIZED) {
      localStorage.setItem('accessToken', '401');
    }
    // else {
    //     localStorage.setItem(
    //         "accessToken",
    //         "d5980fb5e72665a9ebbc1856a0afc9f76a7f252d"
    //     );
    // }
    return response.data;
  });
};
export const imageApi = async (url: string, data: any) => {
  const requestData = await getFetchRequestData(data);
  return fetch(`${getImageAPIURL()}/${url}`, requestData).then((res) => {
    return res.json();
  });
};

export const callChannelListApi = (): Promise<ChannelResponse> =>
  queryApi('/common/service/channel', {});

export const callNewNotiApi = (): Promise<NotificationResponse> =>
  queryApi('/mint/notification/new', {});

export const callDeliveryFee = (): Promise<DeliveryFeeResponse> =>
  queryApi('/common/service/delivery', {});

export default axiosInstance;
